import { CalendarDirectoryPerson } from "../../../interfaces/calendar/calendarDirectoryOptions";

export const normalizeInviteeId = (id: string): string => String(id).toLowerCase();

export const isEmployeeInvitee = (person: CalendarDirectoryPerson): boolean =>
    person.type?.toLowerCase() === "employee";

export const normalizeExternalEmail = (email: string): string =>
    email.trim().toLowerCase();

export const excludeInviteesById = (
    people: CalendarDirectoryPerson[],
    excludedUserIds: string[],
): CalendarDirectoryPerson[] => {
    const excludedIds = new Set(excludedUserIds.map(normalizeInviteeId));
    return people.filter((person) =>
        !excludedIds.has(normalizeInviteeId(person.userId))
    );
};

export const getTeamMembers = (
    people: CalendarDirectoryPerson[],
    teamId: number,
): CalendarDirectoryPerson[] =>
    people.filter((person) =>
        isEmployeeInvitee(person) && person.teamIds?.includes(teamId)
    );

export const resolveInviteeIds = (
    individualUserIds: string[],
    selectedTeamIds: number[],
    people: CalendarDirectoryPerson[],
): string[] => {
    const ids = new Map<string, string>();

    individualUserIds.forEach((id) => {
        if (id) ids.set(normalizeInviteeId(id), id);
    });

    people.forEach((person) => {
        if (
            isEmployeeInvitee(person)
            && person.teamIds?.some((teamId) => selectedTeamIds.includes(teamId))
        ) {
            ids.set(normalizeInviteeId(person.userId), person.userId);
        }
    });

    return Array.from(ids.values());
};

export const isIncludedBySelectedTeam = (
    person: CalendarDirectoryPerson,
    selectedTeamIds: number[],
): boolean => isEmployeeInvitee(person)
    && (person.teamIds?.some((teamId) => selectedTeamIds.includes(teamId)) ?? false);
